import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IInquiry } from "src/@types/inquiries";
import { MY_INQUIRIES_SLICE_NAME } from "./actions";
import {
  changeMyInquiryStatusReducer,
  deleteMyInquiriesReducer,
  getMyInquiriesReducer,
} from "./reducers";

interface IInquiryObject<T> {
  isLoading: boolean;
  data: IResponseWithPagination<T>;
}

export interface IMyInquiriesState {
  myInquiries: IInquiryObject<IInquiry>;
}

const initialState: IMyInquiriesState = {
  myInquiries: {
    isLoading: false,
    data: null,
  },
};
export const { reducer: myInquiries } = createSlice({
  name: MY_INQUIRIES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getMyInquiriesReducer(builder);
    deleteMyInquiriesReducer(builder);
    changeMyInquiryStatusReducer(builder);
  },
});
